import { createFileRoute } from "@tanstack/react-router"
import { BackofficeCanonicalTopics } from "modules/backoffice/components/canonicalTopics"
import { ClusterDomainEnum, TimeFrameEnum, TimeFrameSchema } from "schema"
import { z } from "zod"

const SearchSchema = z.object({
  domain: z.enum(ClusterDomainEnum).optional().default(ClusterDomainEnum.VoiceOfCustomer),
  campaignId: z.string().optional(),
  goalId: z.string().optional(),
  timeFrame: TimeFrameSchema.optional().default(TimeFrameEnum.Last3Months),
})

export const Route = createFileRoute(
  "/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics/list",
)({
  component: BackofficeCanonicalTopics,
  validateSearch: (search: Partial<z.infer<typeof SearchSchema>>) => {
    return SearchSchema.parse(search)
  },
})
